import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import React, { FC, useEffect } from 'react';
import { IconButton, Typography } from '@mui/material';
import { palette } from '../../theme';

const COEYearDateRangeComponent: FC<any> = (props) => {
  const [open, setOpen] = React.useState(false);
  const [startDate, setStartDate] = React.useState('');

  const incrementYear = (step: number) => {
    props.setValue(props.value.add(step, 'year'));
  };

  useEffect(() => {
    // Display format: YYYY-YYYY (e.g., "2024-2025")
    // The start year is from the value, end year is start year + 1
    const startYear = props.value.year();
    const endYear = startYear + 1;
    setStartDate(`${startYear}-${endYear}`);
  }, [props.value]);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        label="Year"
        views={['year']}
        value={props.value}
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        onChange={(newValue) => {
          props.setValue(newValue);
        }}
        renderInput={(params) => (
          <div
            ref={params.inputRef}
            style={{
              display: 'flex',
              alignItems: 'center',
              backgroundColor: palette.grey[100],
              borderRadius: 20,
              height: 36,
              padding: '0 4px',
            }}
          >
            <IconButton onClick={() => incrementYear(-1)} size="small" style={{ padding: 4 }}>
              <KeyboardArrowLeft style={{ color: palette.text.primary, fontSize: 20 }} />
            </IconButton>
            <Typography
              style={{
                color: palette.text.primary,
                fontSize: 14,
                fontWeight: 600,
                cursor: 'pointer',
                padding: '0 8px',
                userSelect: 'none',
              }}
              onClick={() => setOpen(true)}
            >
              {startDate}
            </Typography>
            <IconButton onClick={() => incrementYear(1)} size="small" style={{ padding: 4 }}>
              <KeyboardArrowRight style={{ color: palette.text.primary, fontSize: 20 }} />
            </IconButton>
          </div>
        )}
        disableMaskedInput
      />
    </LocalizationProvider>
  );
};

export default COEYearDateRangeComponent;
